<svg
  width="25"
  height="24"
  viewBox="0 0 25 24"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M15.4286 14.3201V22.003L12.014 19.442L8.59937 22.003V14.3201H15.4286Z"
    fill="#D64747"
  />
  <path
    d="M12.0141 2.61531L13.3644 2.00299L14.4032 3.06384L15.8826 2.98271L16.4696 4.3488L17.8782 4.80986L17.9343 6.29669L19.082 7.23763L18.5995 8.64441L19.3312 9.93815L18.3752 11.0749L18.5921 12.5467L17.2919 13.2599L16.9647 14.711L15.4957 14.9043L14.6686 16.1388L13.2293 15.786L12.0141 16.6371L10.7989 15.786L9.35954 16.1388L8.53251 14.9043L7.06348 14.711L6.73633 13.2599L5.43605 12.5467L5.653 11.0749L4.69702 9.93815L5.42873 8.64441L4.94621 7.23763L6.09385 6.29669L6.14995 4.80986L7.55857 4.3488L8.14564 2.98271L9.62499 3.06384L10.6638 2.00299L12.0141 2.61531Z"
    fill="#FFE352"
  />
  <path
    d="M12.014 14.9095C15.1009 14.9095 17.6034 12.407 17.6034 9.32005C17.6034 6.23309 15.1009 3.73062 12.014 3.73062C8.92703 3.73062 6.42456 6.23309 6.42456 9.32005C6.42456 12.407 8.92703 14.9095 12.014 14.9095Z"
    fill="#FFB236"
  />
  <path
    d="M12.0141 11.3045L9.8551 12.4398L10.2674 10.0353L8.52075 8.33239L10.9346 7.98154L12.0141 5.79385L13.0936 7.98154L15.5075 8.33239L13.7608 10.0353L14.1731 12.4398L12.0141 11.3045Z"
    fill="#FFE352"
  />
</svg>
